export default {"src":"/_next/static/media/recycle.71cfd995.svg","height":96,"width":96};